<script lang="ts" setup>
interface Props {
  freeText: string[]
  hasBorder: boolean
}

defineProps<Props>()
</script>

<template>
  <tr>
    <td colspan="2">
      <table
        v-for="(text, index) in freeText"
        :key="index"
        class="w-full"
        :class="{ 'mt-3': hasBorder && index === 0 }"
      >
        <tr
          :style="
            hasBorder && index === 0 ? 'border-top: 2px dotted #c1c1c1' : ''
          "
        >
          <td class="pt-3">
            <table v-if="index > 0" class="mt-2.5">
              <tr>
                <td />
              </tr>
            </table>

            <SectionsDetailsElementsText :text="text" />
          </td>
        </tr>
      </table>
    </td>
  </tr>
</template>
